/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasPathItem } from '../../models/OasPathItem';
import { OasPaths } from '../../models/OasPaths';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasPaths
 */
export class Oas30Paths extends OasPaths {
    /**
     * @see io.apicurio.datamodels.openapi.models.OasPaths#createPathItem(java.lang.String)
     * @param {string} path
     * @return {OasPathItem}
     */
    public createPathItem(path : string) : OasPathItem {
        let pathItem : Oas30PathItem = new Oas30PathItem(path);
        pathItem._ownerDocument = this.ownerDocument();
        pathItem._parent = this;
        return pathItem;
    }

    constructor() {
        super();
    }
}
Oas30Paths["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Paths";
Oas30Paths["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { Oas30PathItem } from './Oas30PathItem';

